import { Backtop } from 'element-ui'

const YBacktop = Backtop
YBacktop.$depends = [Backtop]
YBacktop.$name = 'y-backtop'
YBacktop._name = 'Backtop 回到顶部'

export default YBacktop
